var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3"},[_c('div',[_vm._t("filters")],2),_vm._v(" "),_c('iframe',{staticClass:"border-0 w-100 insights-iframe",attrs:{"frameborder":"0","allowTransparency":"true","onload":"iFrameResize({}, this)","src":_vm.urlWithQuery}})])
}
var staticRenderFns = []

export { render, staticRenderFns }